export default __webpack_public_path__ + "static/media/image2.6c032dc9.png";